import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RatingLayer from "./RatingLayer";

const RatingPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Ratings" />

        {/* RoleAccessLayer */}
        <RatingLayer />

      </MasterLayout>

    </>
  );
};

export default RatingPage; 
